import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import zhCNTranslation from './locales/zh-CN/translation.json';
import { getHtmlLanguage, normalizeSiteLanguage } from './language';
import { getPathLocale, languageForLocale } from './localizedRoutes';

const initialLocale = getPathLocale(window.location.pathname);

// Initialize i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    lng: initialLocale ? languageForLocale(initialLocale) : undefined,
    // Default language to use if detection fails
    fallbackLng: {
      'zh-CN': ['zh', 'en'],
      zh: ['en'],
      default: ['en'],
    },
    // Debug mode (disable in production)
    debug: false,
    // Resources with translations
    resources: {
      en: {
        translation: enTranslation
      },
      zh: {
        translation: zhTranslation
      },
      'zh-CN': {
        translation: zhCNTranslation
      }
    },
    // Language detection options
    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // Cache user language detection
      caches: ['localStorage', 'cookie'],
      convertDetectedLanguage: (language: string) => normalizeSiteLanguage(language),
    },
    // React i18next special options
    react: {
      useSuspense: true,
    }
  });

const syncDocumentLanguage = (language: string) => {
  document.documentElement.lang = getHtmlLanguage(language);
};

syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;

